import {
  h, defineAsyncComponent, defineComponent,
} from '#imports'
import { createApp, hydrateOnVisible } from 'vue'
import i18n from '@pikpak_web_player/locale'

const AsyncFileManagerContainer = defineAsyncComponent({
  loader: () => import('@/components/file-manager/index.vue'),
  hydrate: hydrateOnVisible(),
})

let activeFileManager: unknown

 export const hasFileManagerVisible = () => !!activeFileManager

 // eslint-disable-next-line @typescript-eslint/ban-ts-comment
 // @ts-ignore
export const closeFileManager = () => activeFileManager?.close?.()

const useFileManager = (
  files: PPFile[],
  selectedId: string,
  scene?: string,
  options?: {
    share_id: string;
    pass_code_token: string;
    t: (k: string) => string;
  },
  onLoaded?: (error?: Error) => void,
) => {
  try {
    if (hasFileManagerVisible()) return activeFileManager

    const Component = defineComponent({
      name: 'FileManagerWrapper',
      setup() {
        return () => h('div', {
          style: {
            position: 'fixed',
            zIndex: '999 !important',
            top: 0,
            left: 0,
            width: '100vw',
            height: 'var(--vh, 100vh)',
          },
        }, [h(AsyncFileManagerContainer, {
          dark: true,
          scene,
          files,
          selectedId,
          shareId: options?.share_id || '',
          passCodeToken: options?.pass_code_token || '',
          t: options?.t || (() => ''),
          onMounted() {
            onLoaded?.()
          },
        })])
      },
    })
    const instance = createApp(Component)
    instance.use(i18n)
    // 挂载
    const vm = instance.mount(document.createElement('div'))
    document.body.appendChild(vm.$el)

    const close = () => {
      vm.$el?.parentNode?.removeChild(vm.$el)
      instance.unmount()
      activeFileManager = undefined
      window.removeEventListener('FILE_MANAGER_CLOSE', close)
    }

    window.addEventListener('FILE_MANAGER_CLOSE', close)

    const result = {
      vm,
      $el: vm.$el,
      close,
    }

    activeFileManager = result

    return result
  } catch (err) {
    console.error(err)
    // 出错了, 关闭 Loading 遮罩
    onLoaded?.(err as Error)
  }
}

export default useFileManager
